import React, { useContext, useEffect } from 'react'
import HomeVideo from '../Components/Home/HomeVideo'
import JoinEec from '../Components/Home/JoinEec'
import UseScrollReveal from '../Common/UseScrollReveal'
import ServiceCenter from '../Components/Home/ServiceCenter'
import WorkBrand from '../Components/Home/WorkBrand'
import FinanceOption from '../Components/Home/FinanceOption'
import FeaturedVehicles from '../Components/Home/FeaturedVehicles'
import HomeAbout from '../Components/Home/HomeAbout'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HomeReviews from '../Components/Home/HomeReviews'
import { VehicleContext } from '../Context/VehicleContext'
import { useLocation, useNavigate } from 'react-router-dom'

const Home = () => {

    const location = useLocation();
    const navigate = useNavigate();
    
    const { vehiclesByVIN, vehicleVINsbyID, getVehicleData, filteredVehicleData, numberFormatter, priceFormatter } = useContext(VehicleContext);
    useEffect(() => {
        getVehicleData();
    }, []);

    useEffect(() => {
            if (location && vehiclesByVIN && vehicleVINsbyID) {
                let vin = location.pathname.slice(location.pathname.lastIndexOf("-") + 1, location.pathname.length);
                if (vin in vehiclesByVIN || vin in vehicleVINsbyID) {
                    console.log("found vehicle ID",vin,vehicleVINsbyID[vin],vehicleVINsbyID);

                    navigate("/vehicle-details" + location.pathname);
                    //setVehicleVIN(vehicleVINsbyID[vin]);
                } 
            }
        }, [location, vehiclesByVIN, vehicleVINsbyID]);

    UseScrollReveal()
    return (
        <>
            <HomeVideo/>
            {/* <HomeLocations/> */}
            <HomeAbout/>
            {filteredVehicleData &&
                <FeaturedVehicles 
                    featuredVehicles={filteredVehicleData.filter((item) => item.inventory_manage.home)} 
                    numberFormatter={numberFormatter} 
                    priceFormatter={priceFormatter} 
                />
            }
            <ServiceCenter/>
            <WorkBrand/>
            <HomeReviews/>
            <FinanceOption/>
            <JoinEec/>
        </>
    )
}

export default Home